import { render, staticRenderFns } from "./LeaderInfo.vue?vue&type=template&id=06960cb9&scoped=true"
import script from "./LeaderInfo.vue?vue&type=script&lang=js"
export * from "./LeaderInfo.vue?vue&type=script&lang=js"
import style0 from "./LeaderInfo.vue?vue&type=style&index=0&id=06960cb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06960cb9",
  null
  
)

export default component.exports